module.exports = __webpack_public_path__ + "assets/img/teacher (56).2ea7a5a2.png";